// 3D clothing rack: renders a collection as garments on a rail with three.js (loaded on demand).
const THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';

function loadThree(cb) {
  if (window.THREE) return cb();
  let s = document.querySelector('script[data-three]');
  if (!s) {
    s = document.createElement('script');
    s.src = THREE_URL;
    s.setAttribute('data-three', '1');
    document.head.appendChild(s);
  }
  s.addEventListener('load', cb);
}

const rack = (function () {
  var HALF = {
    tee:    [[.18,0],[.58,-.08],[.98,-.5],[.82,-.68],[.52,-.46],[.52,-1.5],[0,-1.5]],
    crew:   [[.18,0],[.56,-.08],[.84,-1.0],[.64,-1.04],[.52,-.5],[.52,-1.55],[0,-1.55]],
    jacket: [[.2,0],[.6,-.08],[.94,-.22],[.97,-1.35],[.78,-1.37],[.62,-.55],[.62,-1.5],[0,-1.5]],
    pants:  [[.42,0],[.47,-.25],[.6,-1.7],[.2,-1.7],[.04,-.62],[0,-.58]],
    shorts: [[.42,0],[.48,-.25],[.58,-.95],[.16,-.95],[.04,-.45],[0,-.42]]
  };
  var HANGER_W = {tee:.66, crew:.66, jacket:.7, pants:.5, shorts:.5};
  var FABRIC = {tee:"jersey", crew:"fleece", jacket:"nylon", pants:"denim", shorts:"denim"};
  var COLOR = {tee:"#d8d2c2", crew:"#a89f8e", jacket:"#3a3f48", pants:"#5f7893", shorts:"#8f8772"};
  var LABEL = {tee:"Tees", crew:"Crews", jacket:"Jackets", pants:"Pants", shorts:"Shorts"};
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");
  var RAIL_Y = 2.9;

  // Guess the garment shape from the product's type, title and tags.
  function kind(p) {
    var s = (p.type + " " + p.title + " " + p.tags).toLowerCase();
    if (/jacket|windbreaker|coat|track|starter|bomber|puffer/.test(s)) return "jacket";
    if (/crew|hoodie|sweatshirt|sweater|fleece|quarter zip|pullover/.test(s)) return "crew";
    if (/\bshorts?\b/.test(s) && !/short.?sleeve/.test(s)) return "shorts";
    if (/pant|jean|denim|trouser|baggy|levi|cargo|chino/.test(s)) return "pants";
    return "tee";
  }

  // Shopify's collection loop stops at 50 products, so bigger racks are fetched from the
  // storefront's public products.json (250 per page). If that fails, the inline 50 are used.
  function fetchAll(root, inline) {
    var max = +root.getAttribute("data-max") || 50, total = +root.getAttribute("data-total") || 0;
    var collUrl = root.getAttribute("data-collection-url"), prodBase = root.getAttribute("data-products-base") || "/products/";
    var want = Math.min(max, total || max);
    if (!collUrl || want <= 50) return Promise.resolve(inline);
    var cur = new Intl.NumberFormat(undefined, {style:"currency", currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || "USD", minimumFractionDigits:0, maximumFractionDigits:2});
    var out = [], page = 1;
    function next() {
      return fetch(collUrl + "/products.json?limit=250&page=" + page).then(function (r) { return r.json(); }).then(function (d) {
        var list = d.products || [];
        list.forEach(function (p) {
          var prices = p.variants.map(function (v) { return +v.price; });
          var img = p.images && p.images[0] ? p.images[0].src : null;
          out.push({title:p.title, price:cur.format(Math.min.apply(null, prices)), url:prodBase + p.handle, type:p.product_type || "",
            tags:Array.isArray(p.tags) ? p.tags.join(" ") : (p.tags || ""), available:p.variants.some(function (v) { return v.available; }),
            image:img ? img + (img.indexOf("?") < 0 ? "?" : "&") + "width=700" : null});
        });
        if (list.length === 250 && out.length < want) { page++; return next(); }
        return out.slice(0, want);
      });
    }
    return next().catch(function () { return inline; });
  }

    // Load photos with fetch so cross-origin images arrive CORS-clean as ImageBitmaps.
    function loadPhoto(url, cb, fail) {
      var src = url.indexOf("//") === 0 ? location.protocol + url : url;
      fetch(src, {mode: "cors", credentials: "omit"})
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.blob(); })
        .then(function (b) { return createImageBitmap(b); })
        .then(cb)
        .catch(function () { if (fail) fail(); });
    }

    // Cut the garment out of its product photo: flood-fill the wall from the photo's edges,
    // keep everything the fill can't reach (garment, print, hanger), then crop to it.
    function cutout(img, test) {
      var sw = 240, sh = Math.max(1, Math.round(sw * img.height / img.width));
      var c = document.createElement("canvas"); c.width = sw; c.height = sh;
      var x = c.getContext("2d", {willReadFrequently: true});
      x.drawImage(img, 0, 0, sw, sh);
      var d;
      try { d = x.getImageData(0, 0, sw, sh).data; } catch (e) { return null; }
      var total = sw * sh, bgMask = new Uint8Array(total), queue = new Int32Array(total), qh = 0, qt = 0;
      var ref = [0, 0, 0], rn = 0;
      for (var bx = 0; bx < sw; bx += 4) [bx, (sh - 1) * sw + bx].forEach(function (p) { ref[0] += d[p * 4]; ref[1] += d[p * 4 + 1]; ref[2] += d[p * 4 + 2]; rn++; });
      for (var by = 0; by < sh; by += 4) [by * sw, by * sw + sw - 1].forEach(function (p) { ref[0] += d[p * 4]; ref[1] += d[p * 4 + 1]; ref[2] += d[p * 4 + 2]; rn++; });
      ref = ref.map(function (v) { return v / rn; });
      function dist(a, b) { return Math.abs(d[a * 4] - d[b * 4]) + Math.abs(d[a * 4 + 1] - d[b * 4 + 1]) + Math.abs(d[a * 4 + 2] - d[b * 4 + 2]); }
      function distRef(a) { return Math.abs(d[a * 4] - ref[0]) + Math.abs(d[a * 4 + 1] - ref[1]) + Math.abs(d[a * 4 + 2] - ref[2]); }
      function seed(p) { if (!bgMask[p] && distRef(p) < 120) { bgMask[p] = 1; queue[qt++] = p; } }
      for (var sx = 0; sx < sw; sx++) { seed(sx); seed((sh - 1) * sw + sx); }
      for (var sy = 0; sy < sh; sy++) { seed(sy * sw); seed(sy * sw + sw - 1); }
      while (qh < qt) {
        var p = queue[qh++], px = p % sw, py = (p - px) / sw;
        var nb = [px > 0 ? p - 1 : -1, px < sw - 1 ? p + 1 : -1, py > 0 ? p - sw : -1, py < sh - 1 ? p + sw : -1];
        for (var k = 0; k < 4; k++) {
          var q = nb[k];
          if (q < 0 || bgMask[q]) continue;
          var dr = distRef(q);
          if (dr < 36 || (dist(p, q) < 14 && dr < 110)) { bgMask[q] = 1; queue[qt++] = q; }
        }
      }
      // Photo borders: the outer edge of a product shot (vignette, frame, floor line) often
      // survives the fill, so clear a thin margin and keep only the garment itself (the largest
      // piece, plus anything sizeable attached to it) instead of stray strips along the edges.
      var mg = Math.max(2, Math.round(Math.min(sw, sh) * .025));
      for (var my = 0; my < sh; my++) for (var mxx = 0; mxx < sw; mxx++) {
        if (mxx < mg || my < mg || mxx >= sw - mg || my >= sh - mg) bgMask[my * sw + mxx] = 1;
      }
      var lab = new Int32Array(total), sizes = [0], bestSize = 0, bestId = 0;
      for (var s0 = 0; s0 < total; s0++) {
        if (bgMask[s0] || lab[s0]) continue;
        var cid = sizes.length, csz = 0; qh = 0; qt = 0; queue[qt++] = s0; lab[s0] = cid;
        while (qh < qt) {
          var c0 = queue[qh++], c0x = c0 % sw, c0y = (c0 - c0x) / sw; csz++;
          var cn = [c0x > 0 ? c0 - 1 : -1, c0x < sw - 1 ? c0 + 1 : -1, c0y > 0 ? c0 - sw : -1, c0y < sh - 1 ? c0 + sw : -1];
          for (var ck = 0; ck < 4; ck++) { var cq = cn[ck]; if (cq >= 0 && !bgMask[cq] && !lab[cq]) { lab[cq] = cid; queue[qt++] = cq; } }
        }
        sizes.push(csz);
        if (csz > bestSize) { bestSize = csz; bestId = cid; }
      }
      for (var s1 = 0; s1 < total; s1++) if (!bgMask[s1] && lab[s1] !== bestId && sizes[lab[s1]] < bestSize * .04) bgMask[s1] = 1;
      var minX = sw, maxX = -1, minY = sh, maxY = -1, kept = 0;
      for (var yy = 0; yy < sh; yy++) for (var xx = 0; xx < sw; xx++) {
        if (bgMask[yy * sw + xx]) continue;
        kept++;
        if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
      }
      // Too little or too much left means the wall couldn't be separated (close-ups, busy rooms).
      if (kept < total * .12 || kept > total * .85) return null;
      // Quality gate: only hang pieces that came out as a whole, solid garment.
      // - The wall must be a light, neutral backdrop (close-ups of dark fabric fail here).
      var refL = (ref[0] + ref[1] + ref[2]) / 3, refC = Math.max(ref[0], ref[1], ref[2]) - Math.min(ref[0], ref[1], ref[2]);
      if (refL < 150 || refC > 45) return null;
      // - The garment must fill a garment-sized part of the frame, not just its print.
      var bw = maxX - minX + 1, bh = maxY - minY + 1;
      if (bw < sw * .45 || bh < sh * .45) return null;
      // - The fabric must stand out from the wall. Sample the lower body (below most prints,
      //   above the hem); white or cream pieces on a white wall can't be cut out cleanly, so skip them.
      var fab = [[], [], []];
      for (var gy = minY + Math.round(bh * .66); gy < minY + Math.round(bh * .8); gy++) {
        for (var gx = minX + Math.round(bw * .35); gx < minX + Math.round(bw * .65); gx++) {
          var o = (gy * sw + gx) * 4; fab[0].push(d[o]); fab[1].push(d[o + 1]); fab[2].push(d[o + 2]);
        }
      }
      var fmed = fab.map(function (v) { v.sort(function (a, b) { return a - b; }); return v[v.length >> 1] || 0; });
      var fabDiff = Math.abs(fmed[0] - ref[0]) + Math.abs(fmed[1] - ref[1]) + Math.abs(fmed[2] - ref[2]);
      if (fabDiff < 75) return null;
      if (test) return true;
      var cw = maxX - minX + 1, ch = maxY - minY + 1;
      var m = document.createElement("canvas"); m.width = cw; m.height = ch;
      var mx = m.getContext("2d"), md = mx.createImageData(cw, ch);
      for (var y2 = 0; y2 < ch; y2++) for (var x2 = 0; x2 < cw; x2++) {
        var v = bgMask[(y2 + minY) * sw + x2 + minX] ? 0 : 255, o = (y2 * cw + x2) * 4;
        md.data[o] = md.data[o + 1] = md.data[o + 2] = v; md.data[o + 3] = 255;
      }
      mx.putImageData(md, 0, 0);
      var scale = img.width / sw, OUT = 900 / Math.max(cw, ch);
      var color = document.createElement("canvas"); color.width = Math.round(cw * OUT); color.height = Math.round(ch * OUT);
      color.getContext("2d").drawImage(img, minX * scale, minY * scale, cw * scale, ch * scale, 0, 0, color.width, color.height);
      var alpha = document.createElement("canvas"); alpha.width = color.width; alpha.height = color.height;
      var ax = alpha.getContext("2d"); ax.imageSmoothingEnabled = true; ax.drawImage(m, 0, 0, alpha.width, alpha.height);
      return {color: color, alpha: alpha, aspect: cw / ch, top: minY / sh};
    }

    // Only pieces with a clean, cut-out-able photo go on the rack; others (close-ups, busy shots,
    // missing photos) and any products the merchant listed to leave off are skipped.
    function screen(root, raw) {
      var excl = (root.dataset.exclude || "").split(",").map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var list = raw.filter(function (p) {
        var path = (p.url || "").split("?")[0].toLowerCase();
        return !excl.some(function (h) { return path.slice(-("/products/" + h).length) === "/products/" + h; });
      });
      if (root.getAttribute("data-photos") === "false") return Promise.resolve(list);
      var ok = list.map(function () { return false; }), next = 0;
      function worker() {
        if (next >= list.length) return Promise.resolve();
        var i = next++, p = list[i];
        if (!p.image) return worker();
        return new Promise(function (done) {
          loadPhoto(p.image, function (img) { try { ok[i] = !!cutout(img, true); } catch (e) {} done(); }, done);
        }).then(worker);
      }
      var pool = [];
      for (var w = 0; w < 10; w++) pool.push(worker());
      // Never leave shoppers waiting: after 5 seconds, go with the pieces already confirmed.
      var cap = new Promise(function (r) { setTimeout(r, 5000); });
      return Promise.race([Promise.all(pool), cap]).then(function () { return list.filter(function (p, i) { return ok[i]; }); });
    }

  function init(root) {
    root.setAttribute("data-ready", "1");
    var inline = JSON.parse(root.querySelector(".er-data").textContent || "[]");
    if (!inline.length) { root.querySelector(".er-name").textContent = root.dataset.emptyText; return; }
    root.querySelector(".er-name").textContent = root.dataset.loadingText;
    fetchAll(root, inline).then(function (raw) { return screen(root, raw); }).then(function (raw) {
      if (!raw.length) { root.querySelector(".er-name").textContent = root.dataset.emptyText; return; }
      start(root, raw);
    });
  }

  function start(root, raw) {
    var $ = function (c) { return root.querySelector(c); };
    var usePhotos = root.getAttribute("data-photos") !== "false";
    var ITEMS = raw.map(function (p) {
      var t = kind(p), low = (p.title + " " + p.tags).toLowerCase();
      return {name:p.title, price:p.price, url:p.url, available:p.available, image:p.image, type:t, cat:LABEL[t],
              color:COLOR[t], fabric:FABRIC[t], wide:/baggy|wide|loose/.test(low) ? 1.3 : 1, worn:/distress/.test(low)};
    });

    var cs = getComputedStyle(root);
    var bgColor = new THREE.Color(cs.getPropertyValue("--er-bg").trim());
    var renderer = new THREE.WebGLRenderer({antialias:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    root.insertBefore(renderer.domElement, root.firstChild);
    var scene = new THREE.Scene();
    scene.background = bgColor;
    scene.fog = new THREE.Fog(bgColor, 11, 24);
    var camera = new THREE.PerspectiveCamera(40, 1, .1, 60);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x8a8070, .85));
    var sun = new THREE.DirectionalLight(0xffffff, .9); sun.position.set(-3, 4, 5); scene.add(sun);

    var floor = new THREE.Mesh(new THREE.PlaneGeometry(60, 40), new THREE.MeshStandardMaterial({color:bgColor.clone().multiplyScalar(.93), roughness:1}));
    floor.rotation.x = -Math.PI / 2; scene.add(floor);
    var metal = new THREE.MeshStandardMaterial({color:0xb4b4b4, metalness:.8, roughness:.35});
    var wood = new THREE.MeshStandardMaterial({color:0x8a6a45, roughness:.7});
    var rail = new THREE.Mesh(new THREE.CylinderGeometry(.04, .04, 240, 12), metal);
    rail.rotation.z = Math.PI / 2; rail.position.set(0, RAIL_Y, -.02); scene.add(rail);
    [-1, 1].forEach(function (s) { var p = new THREE.Mesh(new THREE.CylinderGeometry(.05, .05, RAIL_Y, 10), metal); p.position.set(s * 11, RAIL_Y / 2, -.02); scene.add(p); });

    function bar(a, b, r, mat) {
      var d = b.clone().sub(a);
      var m = new THREE.Mesh(new THREE.CylinderGeometry(r, r, d.length(), 6), mat);
      m.position.copy(a).add(b).multiplyScalar(.5);
      m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), d.normalize());
      return m;
    }

    function outline(it) {
      var bottoms = it.type === "pants" || it.type === "shorts";
      var h = HALF[it.type].map(function (p) { return {x:p[0] * (bottoms ? it.wide : 1), y:p[1]}; });
      var left = h.slice(0, -1).reverse().map(function (p) { return {x:-p.x, y:p.y}; });
      var poly = h.concat(left);
      if (!bottoms) poly.push({x:0, y:-.12});
      return poly;
    }

    function makeTextures(it, poly, W, H) {
      var S = 150, cw = Math.ceil(W * S), ch = Math.ceil(H * S);
      function mk() { var c = document.createElement("canvas"); c.width = cw; c.height = ch; return c; }
      var tc = mk(), ac = mk(), t = tc.getContext("2d"), a = ac.getContext("2d");
      function path(c) { c.beginPath(); poly.forEach(function (p, i) { var X = (p.x + W / 2) * S, Y = -p.y * S; if (i) c.lineTo(X, Y); else c.moveTo(X, Y); }); c.closePath(); }
      a.fillStyle = "#000"; a.fillRect(0, 0, cw, ch); path(a); a.fillStyle = "#fff"; a.fill();
      path(t); t.fillStyle = it.color; t.fill(); t.save(); t.clip();
      function lines(step, dx, color) { t.strokeStyle = color; t.lineWidth = 1; t.beginPath(); for (var i = -ch; i < cw; i += step) { t.moveTo(i, 0); t.lineTo(i + dx, ch); } t.stroke(); }
      if (it.fabric === "denim") lines(4, ch * .6, "rgba(255,255,255,.07)");
      if (it.fabric === "nylon") lines(7, 0, "rgba(255,255,255,.06)");
      if (it.fabric === "jersey") { t.strokeStyle = "rgba(0,0,0,.05)"; t.beginPath(); for (var y = 0; y < ch; y += 3) { t.moveTo(0, y); t.lineTo(cw, y); } t.stroke(); }
      var speck = it.fabric === "fleece" ? 5 : 14;
      for (var n = 0; n < cw * ch / speck; n++) { t.fillStyle = Math.random() < .5 ? "rgba(255,255,255,.06)" : "rgba(0,0,0,.07)"; t.fillRect(Math.random() * cw, Math.random() * ch, 1.6, 1.6); }
      if (it.worn) for (var k = 0; k < 26; k++) { t.fillStyle = "rgba(255,255,255,.1)"; t.beginPath(); t.ellipse(Math.random() * cw, (.25 + Math.random() * .7) * ch, 10 + Math.random() * 16, 3 + Math.random() * 5, Math.random() * 3, 0, 7); t.fill(); }
      var dark = "rgba(0,0,0,.22)", mid = cw / 2;
      if (it.type === "tee" || it.type === "crew") { t.strokeStyle = dark; t.lineWidth = 7; t.beginPath(); t.ellipse(mid, 0, .18 * S, .13 * S, 0, 0, Math.PI); t.stroke(); }
      if (it.type === "crew") { t.fillStyle = dark; t.fillRect(0, (H - .14) * S, cw, .14 * S); [-1, 1].forEach(function (s) { t.fillRect(mid + s * .74 * S - .11 * S, .94 * S, .22 * S, .1 * S); }); }
      if (it.type === "jacket") {
        t.fillStyle = dark; t.fillRect(0, (H - .12) * S, cw, .12 * S);
        t.strokeStyle = "rgba(225,225,225,.7)"; t.lineWidth = 2; t.beginPath(); t.moveTo(mid, .1 * S); t.lineTo(mid, H * S); t.stroke();
      }
      if (it.type === "pants" || it.type === "shorts") {
        t.fillStyle = dark; t.fillRect(0, 0, cw, .1 * S);
        t.strokeStyle = "rgba(0,0,0,.3)"; t.lineWidth = 2; t.beginPath(); t.moveTo(mid, 0); t.lineTo(mid, .42 * S); t.stroke();
      }
      t.restore();
      return {map:new THREE.CanvasTexture(tc), alpha:new THREE.CanvasTexture(ac)};
    }

    // Flat grid -> soft hanging folds (deeper toward the hem).
    function drape(geo, W, H, sign, seed) {
      var p = geo.attributes.position;
      for (var i = 0; i < p.count; i++) {
        var u = p.getX(i) / (W / 2), v = (H / 2 - p.getY(i)) / H;
        var amp = .012 + .075 * v;
        var fold = Math.sin(u * (5 + seed) * (1 + v * .5) + seed * 1.7) * .6 + Math.sin(u * (11 + seed * 2) + seed) * .4;
        var belly = .06 * (1 - u * u) * Math.sin(Math.min(1, v * 2.2) * Math.PI / 2);
        p.setZ(i, sign * (.05 + belly) + fold * amp * (sign > 0 ? 1 : .7));
      }
      geo.computeVertexNormals();
    }


    // Find the garment inside a product photo: rows that differ from the wall color
    // across a good share of their width are garment; the thin hanger and hook are skipped.
    function garmentBox(img) {
      var sw = 120, sh = Math.max(1, Math.round(sw * img.height / img.width));
      var c = document.createElement("canvas"); c.width = sw; c.height = sh;
      var x = c.getContext("2d", {willReadFrequently: true});
      x.drawImage(img, 0, 0, sw, sh);
      var d;
      try { d = x.getImageData(0, 0, sw, sh).data; } catch (e) { return null; }
      var bg = [0, 0, 0], n = 0;
      [[2, 2], [sw - 3, 2], [2, sh - 3], [sw - 3, sh - 3], [Math.floor(sw / 2), 2]].forEach(function (p) {
        var o = (p[1] * sw + p[0]) * 4; bg[0] += d[o]; bg[1] += d[o + 1]; bg[2] += d[o + 2]; n++;
      });
      bg = bg.map(function (v) { return v / n; });
      var minX = sw, maxX = -1, minY = sh, maxY = -1;
      for (var yy = 0; yy < sh; yy++) {
        var rowMin = sw, rowMax = -1, hits = 0;
        for (var xx = 0; xx < sw; xx++) {
          var o = (yy * sw + xx) * 4;
          var dist = Math.abs(d[o] - bg[0]) + Math.abs(d[o + 1] - bg[1]) + Math.abs(d[o + 2] - bg[2]);
          if (dist > 60) { hits++; if (xx < rowMin) rowMin = xx; if (xx > rowMax) rowMax = xx; }
        }
        if (hits > sw * .18) {
          if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          if (rowMin < minX) minX = rowMin; if (rowMax > maxX) maxX = rowMax;
        }
      }
      if (maxX < 0 || (maxX - minX) * (maxY - minY) < sw * sh * .2) return null;
      var k = img.width / sw;
      return {x: minX * k, y: minY * k, w: (maxX - minX + 1) * k, h: (maxY - minY + 1) * k};
    }

    // Crop the product photo to the garment and stretch it across the silhouette.
    function photoTexture(img, W, H) {
      var box = garmentBox(img);
      if (!box) {
        // Close-ups and busy backgrounds: use a centered crop that matches the silhouette.
        var ia = img.width / img.height, ga = W / H, bw = img.width, bh = img.height;
        if (ia > ga) bw = img.height * ga; else bh = img.width / ga;
        box = {x: (img.width - bw) / 2, y: (img.height - bh) / 2, w: bw, h: bh};
      }
      var S = 300, c = document.createElement("canvas");
      c.width = Math.ceil(W * S); c.height = Math.ceil(H * S);
      c.getContext("2d").drawImage(img, box.x, box.y, box.w, box.h, 0, 0, c.width, c.height);
      var t = new THREE.CanvasTexture(c);
      t.anisotropy = 4;
      return t;
    }


    function makeItem(it, i) {
      var g = new THREE.Group();
      var V = function (x, y) { return new THREE.Vector3(x, y, 0); }, hw = HANGER_W[it.type];
      var apex = V(0, -.17), s1 = V(hw, -.47), s2 = V(-hw, -.47);
      var hangerParts = [bar(apex, s1, .012, wood), bar(apex, s2, .012, wood), bar(s1, s2, .012, wood), bar(V(0, -.05), apex, .012, metal)];
      hangerParts.forEach(function (h) { g.add(h); });
      var hook = new THREE.Mesh(new THREE.TorusGeometry(.06, .012, 6, 18, Math.PI * 1.6), metal);
      hook.rotation.z = Math.PI * .2; g.add(hook);

      var poly = outline(it);
      var W = 2 * Math.max.apply(null, poly.map(function (p) { return p.x; }));
      var H = -Math.min.apply(null, poly.map(function (p) { return p.y; }));
      var tex = makeTextures(it, poly, W, H);
      var mat = new THREE.MeshStandardMaterial({map:tex.map, alphaMap:tex.alpha, alphaTest:.5, roughness:.95, side:THREE.DoubleSide});
      var cloth = [];
      [1, -1].forEach(function (sign) {
        var geo = new THREE.PlaneGeometry(W, H, 28, 38);
        drape(geo, W, H, sign, i % 5);
        var mesh = new THREE.Mesh(geo, mat);
        mesh.position.y = -.4 - H / 2;
        g.add(mesh);
        cloth.push(mesh);
      });
      // While the photo loads, the generic garment stays faint so there's no blank gap on the rail.
      if (usePhotos && it.image) {
        mat.transparent = true; mat.opacity = .35;
        loadPhoto(it.image, function (img) {
          if (g.userData.dead) return;
          var cut = cutout(img);
          if (cut) {
            // Replace the stand-in with the real garment, cut out of its photo, hanger and all.
            var Hc = 2.25, Wc = Hc * cut.aspect;
            if (Wc > 2.3) { Wc = 2.3; Hc = Wc / cut.aspect; }
            cloth.concat(hangerParts).forEach(function (o) { g.remove(o); o.geometry.dispose(); });
            if (mat.map) mat.map.dispose();
            if (mat.alphaMap) mat.alphaMap.dispose();
            mat.dispose();
            var map = new THREE.CanvasTexture(cut.color), am = new THREE.CanvasTexture(cut.alpha);
            map.anisotropy = 4;
            var real = new THREE.MeshStandardMaterial({map: map, alphaMap: am, alphaTest: .5, roughness: .9, side: THREE.DoubleSide});
            var geo = new THREE.PlaneGeometry(Wc, Hc, 24, 32);
            var p = geo.attributes.position;
            for (var n = 0; n < p.count; n++) {
              var u = p.getX(n) / (Wc / 2), v = (Hc / 2 - p.getY(n)) / Hc;
              p.setZ(n, .04 + .05 * (1 - u * u) * v + Math.sin(u * 6 + i) * .015 * v);
            }
            geo.computeVertexNormals();
            var mesh = new THREE.Mesh(geo, real);
            mesh.position.y = -.06 - Hc / 2;
            g.add(mesh);
            g.userData.mat = real;
          } else {
            var photo = photoTexture(img, W, H);
            if (mat.map) mat.map.dispose();
            mat.map = photo; mat.opacity = 1; mat.transparent = false; mat.needsUpdate = true;
          }
        });
      }
      g.userData.i = i;
      g.userData.mat = mat;
      scene.add(g);
      return g;
    }
    function disposeItem(g) {
      g.userData.dead = true;
      g.traverse(function (o) { if (o.geometry) o.geometry.dispose(); });
      var m = g.userData.mat;
      if (m.map) m.map.dispose();
      if (m.alphaMap) m.alphaMap.dispose();
      m.dispose();
      scene.remove(g);
    }
    // Only the garments near the focused one exist at any time, so 100+ products stay smooth.
    var groups = ITEMS.map(function () { return null; }), WINDOW = 16;
    function manage(center, maxBuild) {
      var built = 0;
      for (var i = 0; i < ITEMS.length; i++) {
        var dist = Math.abs(i - center);
        if (dist <= WINDOW && !groups[i] && built < maxBuild) { groups[i] = makeItem(ITEMS[i], i); built++; }
        else if (dist > WINDOW + 6 && groups[i]) { disposeItem(groups[i]); groups[i] = null; }
      }
    }

    function resize() {
      var w = root.clientWidth, h = root.clientHeight;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.position.set(0, 1.7, w / h < 1 ? 10.5 : 7.4);
      camera.lookAt(0, 1.5, 0);
      camera.updateProjectionMatrix();
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(root); else window.addEventListener("resize", resize);
    resize();

    // Open on the middle piece so there is rack to flip through in both directions.
    var N = ITEMS.length, f = Math.floor((N - 1) / 2), target = f, shown = -1;
    var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
    var go = function (i) { target = clamp(Math.round(i), 0, N - 1); };
    var scrub = $(".er-scrub"); scrub.max = N - 1;
    scrub.oninput = function () { go(+scrub.value); };
    function showInfo(i) {
      if (i === shown) return; shown = i;
      var it = ITEMS[i];
      $(".er-count").textContent = (i + 1) + " / " + N;
      if (document.activeElement !== scrub) scrub.value = i;
      $(".er-name").textContent = it.name;
      $(".er-sub").textContent = [it.price, it.cat, it.available ? "" : root.dataset.soldOutText].filter(Boolean).join(" · ");
      $(".er-shop").href = it.url;
    }
    $(".er-prev").onclick = function () { go(Math.round(target) - 1); };
    $(".er-next").onclick = function () { go(Math.round(target) + 1); };
    root.addEventListener("keydown", function (e) { if (e.target === scrub) return; if (e.key === "ArrowRight") go(Math.round(target) + 1); if (e.key === "ArrowLeft") go(Math.round(target) - 1); });

    var cv = renderer.domElement, ray = new THREE.Raycaster(), mouse = new THREE.Vector2();
    var down = null, downY = 0, startF = 0, moved = false, wheelT, vel = 0, lastX = 0, lastT = 0, PX = 70;
    // Swipes are read on the whole rack (not just the 3D canvas) so the hint overlay never blocks them;
    // the info panel keeps its own buttons and slider.
    var inPanel = function (e) { return e.target.closest && e.target.closest(".er-panel"); };
    root.addEventListener("pointerdown", function (e) {
      if (inPanel(e) || (e.pointerType === "mouse" && e.button !== 0)) return;
      down = e.clientX; downY = e.clientY; startF = target; moved = false; vel = 0; lastX = e.clientX; lastT = performance.now();
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
    });
    root.addEventListener("pointermove", function (e) {
      if (down === null) return;
      var dx = e.clientX - down;
      if (!moved && Math.abs(dx) > 5 && Math.abs(dx) > Math.abs(e.clientY - downY)) moved = true;
      if (moved) { e.preventDefault(); target = clamp(startF - dx / PX, 0, N - 1); }
      var now = performance.now();
      if (now > lastT) vel = .8 * vel + .2 * (-(e.clientX - lastX) / PX) / (now - lastT);
      lastX = e.clientX; lastT = now;
    });
    var release = function () { down = null; go(target); };
    root.addEventListener("pointercancel", release);
    root.addEventListener("lostpointercapture", function () { if (down !== null) release(); });
    root.addEventListener("pointerup", function (e) {
      if (down === null) return; down = null;
      if (moved) { if (performance.now() - lastT > 80) vel = 0; go(target + vel * 220); return; }
      var r = cv.getBoundingClientRect();
      mouse.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(mouse, camera);
      var hit = ray.intersectObjects(groups.filter(Boolean), true)[0];
      var o = hit && hit.object;
      while (o && o.userData.i === undefined) o = o.parent;
      if (o && o.userData.i !== Math.round(target)) { go(o.userData.i); return; }
      // A tap on the focused piece opens it; a tap on empty rail steps toward that side.
      if (o) { window.location.href = ITEMS[o.userData.i].url; return; }
      var side = (e.clientX - r.left) / r.width;
      if (side < .4) go(Math.round(target) - 1); else if (side > .6) go(Math.round(target) + 1);
    });
    // Horizontal trackpad scrolling flips the rack; vertical scrolling still scrolls the page.
    root.addEventListener("wheel", function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      target = clamp(target + e.deltaX / 260, 0, N - 1);
      clearTimeout(wheelT); wheelT = setTimeout(function () { go(target); }, 140);
    }, {passive:false});

    var smooth = function (s) { return s * s * (3 - 2 * s); };
    function tick(ms) {
      if (!document.body.contains(root)) { renderer.dispose(); return; }
      var t = ms / 1000;
      f += (target - f) * (REDUCED.matches ? 1 : .12);
      var sway = REDUCED.matches ? 0 : 1;
      manage(Math.round(f), 3);
      groups.forEach(function (g, i) {
        if (!g) return;
        var d = i - f, s = Math.min(1, Math.abs(d)), k = smooth(s);
        g.position.set(d * .34 + clamp(d, -1, 1) * 1.25, RAIL_Y - .02, .7 * (1 - k));
        g.rotation.y = -1.1 * k + sway * Math.sin(t * 1.3 + i) * (.015 + .02 * k);
        g.rotation.z = sway * Math.sin(t * 1.1 + i * 1.7) * .012;
      });
      showInfo(clamp(Math.round(f), 0, N - 1));
      renderer.render(scene, camera);
      requestAnimationFrame(tick);
    }
    manage(Math.round(f), 99);
    requestAnimationFrame(tick);
  }
  return { init: init };
})();

class ElginRack extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-ready')) return;
    loadThree(() => {
      if (this.isConnected && !this.hasAttribute('data-ready')) rack.init(this);
    });
  }
}

if (!customElements.get('s-elgin-rack')) customElements.define('s-elgin-rack', ElginRack);
